// Below method sorts an array according to a provided map as shown in below example
// array : ["Daily", "Half Yearly", "Monthly", "Quarterly", "Weekly", "Yearly"]
// map : {
//     Daily: 0,
//     Weekly: 1,
//     Monthly: 2,
//     Quarterly: 3,
//     "Half Yearly": 4,
//     Yearly: 5,
//   }
export const sortArrayAccToMap = (array, map) => {
  const sortedArray = array.sort((a, b) => {
    if (map[a] < map[b]) {
      return -1;
    }
    if (map[a] > map[b]) {
      return 1;
    }
    return 0;
  });
  return sortedArray;
};

/**
 * @param {number} num - The number to round
 * @param {number} precision - The number of decimal places to preserve
 * @return (192.168, 1) //=> 192.2
 */
export const roundUpByDecimal = (num, precision) => {
  precision = 10 ** precision; // Exponentiation Operator
  return Math.ceil(num * precision) / precision;
};

/**
 * @param {number} num - The number to round
 * @param {number} precision - The number to round to the nearest given value
 * @return (11, 10) //=> 20
 */
export const roundUpByNumber = (num, precision) =>
  Math.ceil(num / precision) * precision;

/**
 * @param {number} num - The number to roun
 * @return (192.168) //=> 193
 */
export const roundUpByUnit = num => Math.ceil(num);



// WEBPACK FOOTER //
// ./src/utils/programUtils.js